import React from 'react';
import { Edit2 } from 'lucide-react';

/**
 * EditedBadge - tiny inline badge shown next to entities that have been
 * admin-edited. Hover reveals the last reason + editor + timestamp.
 *
 * Renders nothing if no edit metadata is present.
 */
export const EditedBadge = ({ lastEditedAt, lastEditedBy, lastEditReason }) => {
  if (!lastEditedAt && !lastEditedBy && !lastEditReason) return null;

  const when = lastEditedAt ? new Date(lastEditedAt).toLocaleString() : 'unknown time';
  const who = lastEditedBy || 'unknown';
  const why = lastEditReason || '(no reason given)';

  return (
    <span
      className="inline-flex items-center gap-0.5 ml-1 px-1.5 py-0.5 rounded text-[10px] font-medium bg-amber-100 text-amber-800 border border-amber-300 cursor-help align-middle"
      title={`Edited by ${who} on ${when}\nReason: ${why}`}
      data-testid="edited-badge"
    >
      <Edit2 className="w-2.5 h-2.5" />
      Edited
    </span>
  );
};
